import styled from 'styled-components';
import { DEFAULT_RISK_RPN_COLOR } from '@/utils/constants';

export const Container = styled.div`
	padding: 0 14px;
	font-size: 1.2rem;
	font-weight: 600;
	border-radius: 6px;
	color: ${DEFAULT_RISK_RPN_COLOR};
	border: 2px solid ${DEFAULT_RISK_RPN_COLOR};
	background-color: #eaeefd;
`;
